import { render, staticRenderFns } from "./DiamondExchange.vue?vue&type=template&id=60e579ae&scoped=true"
import script from "./DiamondExchange.vue?vue&type=script&lang=js"
export * from "./DiamondExchange.vue?vue&type=script&lang=js"
import style0 from "./DiamondExchange.vue?vue&type=style&index=0&id=60e579ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e579ae",
  null
  
)

export default component.exports